'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import Mailto from '../components/Mailto'

let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--contact'
        // Fns
        new Mailto(this.view)
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
        }, 200);
    }

    intro()
    {
        const tl = new TimelineLite()
        const $bg = this.view.querySelector('.bg')
        const $content = this.view.querySelector('.inner')
        tl.add([
            TweenLite.fromTo($bg , .8 , { opacity : 0 , scale : 1.05 } , { opacity : 1 , scale : 1 , ease : Cubic.easeOut }),
            TweenLite.fromTo($content , .8 , { opacity : 0 , y : 50 } , { opacity : 1, y : 0 , ease : Power4.easeOut , delay : .2 }),
        ])
    }
}

page = Barba.BaseView.extend({
    namespace: 'contact',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;


// WEBPACK FOOTER //
// ./resources/js/view/contact.js